import { UnreadBadgeCountStyled } from './UnreadBadgeCount.styled';

export type UnreadBadgeCountProps = {
  count: number;
};

export function UnreadBadgeCount({ count }: UnreadBadgeCountProps) {
  return <UnreadBadgeCountStyled>{count}</UnreadBadgeCountStyled>;
}
